import { IAuthRepository } from "@/core/repositories/auth";

export class IsAuthenticatedCheckUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(): Promise<boolean> {
    return await this.authRepository.isAuthenticated();
  }
}
